import {ApplicationConfig, provideZoneChangeDetection} from '@angular/core';
import {provideRouter} from '@angular/router';

import {routes} from './app.routes';
import {DecimalPipe} from '@angular/common';
import {HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import {DEFAULT_TIMEOUT, TimeoutInterceptor} from './services/timeout-interceptor';
import {FONT_PICKER_CONFIG, FontPickerConfigInterface} from 'ngx-font-picker';
import {JWT_OPTIONS, JwtHelperService} from '@auth0/angular-jwt';
import {TranslateLoader, TranslateModule, TranslateService} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';

const DEFAULT_FONT_PICKER_CONFIG: FontPickerConfigInterface = {
  apiKey: 'AIzaSyC20YeNBiTl32CEkQsGuN1wNa2JqBNG74A'
};

export function createTranslateLoader(http: HttpClient) {
  let time = new Date().getTime();
  return new TranslateHttpLoader(http, './assets/i18n/', '.json?v=' + time);
}

export function jwtOptionsFactory() {
  return {
    tokenGetter: () => localStorage.getItem('access_token'), // Adjust as needed
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({eventCoalescing: true}),
    provideRouter(routes),
    DecimalPipe,
    {provide: FONT_PICKER_CONFIG, useValue: DEFAULT_FONT_PICKER_CONFIG},
    {provide: HTTP_INTERCEPTORS, useClass: TimeoutInterceptor, multi: true},
    {provide: DEFAULT_TIMEOUT, useValue: 100000},
    provideHttpClient(withInterceptorsFromDi()),
    {provide: JWT_OPTIONS, useFactory: jwtOptionsFactory},
    JwtHelperService,
    TranslateService,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient],
      },
    }).providers
  ]
};
